/**
 * @param {number} length
 * @return {Array}
 */
export default (function (length) {
  return Array.apply(null, { length: length });
});


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/range.js
// module id = 460
// module chunks = 1